/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnChanges } from '@angular/core';
import { DataService } from '../../services/data.service';
import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import {
  Stroke,
  Style,
} from 'ol/style';
import Polyline from 'ol/format/Polyline';
import Feature from 'ol/Feature';
import VectorSource from 'ol/source/Vector';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';


@Component({
  selector: 'app-segment',
  templateUrl: './segment.component.html',
  styleUrls: ['./segment.component.scss'],
})
export class SegmentComponent implements OnChanges {
  @Input() segmentId;
  @Input() polyline: string;
  @Input() width = '40vw';
  @Input() height = '100px';
  @Input() mapId = 'ol-map';
  @Input() layer = 'light';
  segment;
  map;
  vectorLayer;
  styles;
  layersMap = {
    default:
      'https://c.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@4x.png',
    road: 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&scale=2',
    satellite: 'https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}&scale=2',
    hybrid: 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&scale=2',
    terrain: 'https://mt1.google.com/vt/lyrs=p&x={x}&y={y}&z={z}&scale=2',
    dark: 'https://c.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}@4x.png',
    light:
      'https://c.basemaps.cartocdn.com/rastertiles/light_all/{z}/{x}/{y}@4x.png',
  };

  constructor(private dataService: DataService) {}

  ngOnChanges() {
    this.getSegmentDetails(this.segmentId);
  }

  getSegmentDetails(id) {
    this.dataService.getSegmentDetails(id).subscribe((segment) => {
      this.segment = segment;
      this.styles = {
        route: new Style({
          stroke: new Stroke({
            width: 2,
            color: 'darkgray',
          }),
        }),
        line: new Style({
          stroke: new Stroke({
            width: 2,
            color: 'rgba(252, 76, 2,1)',
          }),
        }),
      };
      setTimeout(() => this.generateMap());
    });
  }

  generateMap() {
    const route = new Polyline({
      factor: 1e5,
    }).readGeometry(this.polyline, {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857',
    });
    const routeFeature = new Feature({
      type: 'route',
      geometry: route,
    });
    const vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: [routeFeature],
      }),
      style: (feature) => this.styles[feature.get('type')],
    });

    const segmentLine = new Polyline({
      factor: 1e5,
    }).readGeometry(this.segment.map.polyline, {
      dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:3857',
    });
    const previewLine = new Feature({
      type: 'line',
      geometry: segmentLine,
    });
    const previewVector = new VectorLayer({
      source: new VectorSource({
        features: [previewLine],
      }),
      style: new Style({
        stroke: new Stroke({
          color: 'rgba(252, 76, 2, 1)',
          width: 2,
        }),
      }),
    });

    const myLayers: any = [vectorLayer, previewVector];
    const baseLayer = new TileLayer({
        source: new XYZ({
          url: this.layersMap[this.layer],
          tileSize: 256,
          crossOrigin: 'anonymous',
        }),
      });
    myLayers.unshift(baseLayer);
    this.map = new Map({
      view: new View({
        center: route.getExtent(),
        showFullExtent: true,
      }),
      layers: myLayers,
      controls: [],
      target: this.mapId,
    });
    setTimeout(() => {
      this.map.updateSize();
      window.dispatchEvent(new Event('resize'));
      const padding = [50, 50, 50, 50];
      this.map
        .getView()
        .fit(previewLine.getGeometry().getExtent(), { padding });
    }, 1000);
  }
}
